<template>
 <div class="position-relative" id="app">
    <router-view />
    <feedback />
    <div v-if="showDataSourceListComponent" class="position-fixed datasource-list">
      <ShowDataSourcesList />
    </div>
      <div v-if="showWhatsNewComponent" class="position-fixed whats-new">
      <WhatsNew />
    </div>
    <div v-if="showShareSectionComponent" class="position-fixed whats-new">
      <ShareSection />
    </div>

    <!-- Global Modals -->
    <IndicatorExplanationModal />

     <div class="fun-fact-trigger" aria-label="Show fun fact" @click="toggleFunFact()">
      <span class="fun-fact-trigger-ring"></span>
      <svg class="bulb-svg" viewBox="0 0 512 512">
        <!-- keep your SVG exactly as is -->
        <!-- no inline width/height anymore -->

        <path style="fill: #e8edee" d="M185.379,370.759V476.69h141.241v-70.621v-35.31H185.379z" />
        <path
          style="fill: #cbd4d8"
          d="M269.241,512h-26.483c-7.945,0-15.89-3.531-21.186-10.593l-18.538-24.717h105.931l-18.538,24.717C285.131,508.469,277.186,512,269.241,512"
        />

        <!-- 💡 MAIN BULB (we'll target this) -->
        <path
          class="bulb-glow"
          style="fill: #f0ce49"
          d="M422.841,152.717C414.014,73.269,350.455,9.71,271.007,0.883C265.71,0.883,261.297,0,256,0
      c-5.297,0-9.71,0-15.007,0.883C161.545,9.71,97.986,74.152,89.159,152.717c-6.179,56.497,15.007,107.697,52.083,143.007
      c21.186,20.303,38.841,46.786,44.138,75.034h141.241c5.297-28.248,22.952-54.731,44.138-75.034
      C407.834,260.414,429.021,209.214,422.841,152.717"
        />

        <path
          style="fill: #ffffff"
          d="M326.621,158.897h-52.966l44.138-79.448h-52.966l-61.793,114.759h44.138l-44.138,114.759L326.621,158.897z"
        />
      </svg>
    </div>

     <transition name="fun-fact-slide">
      <div v-if="!isFunFactDisabled && showFunFact && nugget" class="fun-fact">
        <button
          class="fun-fact-disable text-danger"
          aria-label="Disable fun facts"
          @click="toggleDisablePrompt"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 -0.5 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#FF2C2C"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M11.75 9.874C11.75 10.2882 12.0858 10.624 12.5 10.624C12.9142 10.624 13.25 10.2882 13.25 9.874H11.75ZM13.25 4C13.25 3.58579 12.9142 3.25 12.5 3.25C12.0858 3.25 11.75 3.58579 11.75 4H13.25ZM9.81082 6.66156C10.1878 6.48991 10.3542 6.04515 10.1826 5.66818C10.0109 5.29121 9.56615 5.12478 9.18918 5.29644L9.81082 6.66156ZM5.5 12.16L4.7499 12.1561L4.75005 12.1687L5.5 12.16ZM12.5 19L12.5086 18.25C12.5029 18.25 12.4971 18.25 12.4914 18.25L12.5 19ZM19.5 12.16L20.2501 12.1687L20.25 12.1561L19.5 12.16ZM15.8108 5.29644C15.4338 5.12478 14.9891 5.29121 14.8174 5.66818C14.6458 6.04515 14.8122 6.48991 15.1892 6.66156L15.8108 5.29644ZM13.25 9.874V4H11.75V9.874H13.25ZM9.18918 5.29644C6.49843 6.52171 4.7655 9.19951 4.75001 12.1561L6.24999 12.1639C6.26242 9.79237 7.65246 7.6444 9.81082 6.66156L9.18918 5.29644ZM4.75005 12.1687C4.79935 16.4046 8.27278 19.7986 12.5086 19.75L12.4914 18.25C9.08384 18.2892 6.28961 15.5588 6.24995 12.1513L4.75005 12.1687ZM12.4914 19.75C16.7272 19.7986 20.2007 16.4046 20.2499 12.1687L18.7501 12.1513C18.7104 15.5588 15.9162 18.2892 12.5086 18.25L12.4914 19.75ZM20.25 12.1561C20.2345 9.19951 18.5016 6.52171 15.8108 5.29644L15.1892 6.66156C17.3475 7.6444 18.7376 9.79237 18.75 12.1639L20.25 12.1561Z"
                fill="#FF2C2C"
              ></path>
            </g>
          </svg>
        </button>
        <button class="fun-fact-close" aria-label="Close fun fact" @click="closeFunFact">
          <svg viewBox="0 0 20 20" aria-hidden="true" class="fun-fact-close-icon">
            <path d="M5.5 5.5L14.5 14.5M14.5 5.5L5.5 14.5" />
          </svg>
        </button>
        <div class="fun-fact-glow"></div>
        <div class="fun-fact-icon">
          <!-- Light bulb SVG -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="bulb-icon"
          >
            <path
              d="M9 21h6v-1H9v1zm3-20C7.935 1 5 3.935 5 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 001 1h6a1 1 0 001-1v-4.26c1.81-1.27 3-3.36 3-5.74 0-3.065-2.935-6-6-6z"
            />
          </svg>
        </div>

        <div class="fun-fact-content">
          <div class="fun-fact-meta">
            <p class="fun-fact-label">Curated Insight</p>
            <span class="fun-fact-kicker">From your MSDAT context</span>
          </div>
          <div class="fun-fact-divider"></div>
          <h1 class="fun-fact-text">
            <span class="fun-fact-quote-mark">“</span>{{ nugget }}
          </h1>
          <p class="fun-fact-caption">A concise signal surfaced for the dashboard you are exploring.</p>
        </div>
      </div>
    </transition>

    <!-- Global Chatbot - Commented out -->
    <!-- <div class="global-chatbot-wrapper">
      <ChatBot ref="globalChatBot" />
      <button
        class="global-chat-trigger"
        @click="$refs.globalChatBot.toggleChat()"
        title="Metadata Chatbot"
        aria-label="Open AI Chatbot"
      >
        <svg width="24" height="24" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 0C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2C13 2.74 12.6 3.39 12 3.73V5H13C14.8565 5 16.637 5.7375 17.9497 7.05025C19.2625 8.36301 20 10.1435 20 12H21C21.2652 12 21.5196 12.1054 21.7071 12.2929C21.8946 12.4804 22 12.7348 22 13V16C22 16.2652 21.8946 16.5196 21.7071 16.7071C21.5196 16.8946 21.2652 17 21 17H20V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V17H1C0.734784 17 0.48043 16.8946 0.292893 16.7071C0.105357 16.5196 0 16.2652 0 16V13C0 12.7348 0.105357 12.4804 0.292893 12.2929C0.48043 12.1054 0.734784 12 1 12H2C2 10.1435 2.7375 8.36301 4.05025 7.05025C5.36301 5.7375 7.14348 5 9 5H10V3.73C9.4 3.39 9 2.74 9 2C9 1.46957 9.21071 0.960859 9.58579 0.585786C9.96086 0.210714 10.4696 0 11 0ZM6.5 11C5.83696 11 5.20107 11.2634 4.73223 11.7322C4.26339 12.2011 4 12.837 4 13.5C4 14.163 4.26339 14.7989 4.73223 15.2678C5.20107 15.7366 5.83696 16 6.5 16C7.16304 16 7.79893 15.7366 8.26777 15.2678C8.73661 14.7989 9 14.163 9 13.5C9 12.837 8.73661 12.2011 8.26777 11.7322C7.79893 11.2634 7.16304 11 6.5 11ZM15.5 11C14.837 11 14.2011 11.2634 13.7322 11.7322C13.2634 12.2011 13 12.837 13 13.5C13 14.163 13.2634 14.7989 13.7322 15.2678C14.2011 15.7366 14.837 16 15.5 16C16.163 16 16.7989 15.7366 17.2678 15.2678C17.7366 14.7989 18 14.163 18 13.5C18 12.837 17.7366 12.2011 17.2678 11.7322C16.7989 11.2634 16.163 11 15.5 11Z" fill="white"/>
        </svg>
      </button>
    </div> -->
     <transition name="fade-slide">
      <div v-if="showDisablePrompt" class="funfact-modal">
        <div class="icon">💡</div>

        <div class="content">
          <p class="title">Disable Fun Facts?</p>
          <p class="desc">You can turn it back on anytime by clicking the bulb icon.</p>

          <div class="actions">
            <button class="cancel" @click="toggleDisablePrompt">Cancel</button>
            <button class="confirm" @click="disableFunFact">Disable</button>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import feedback from './views/feedback.vue';
import ShowDataSourcesList from './modules/dynamic_dashboard/components/ShowDataSourcesList.vue';
import WhatsNew from './modules/dynamic_dashboard/components/WhatsNew.vue';
import ShareSection from './modules/dynamic_dashboard/components/ShareSection.vue';// import ChatBot from './modules/msdat-dashboard/components/ChatBot.vue';
import IndicatorExplanationModal from './components/ui-components/IndicatorExplanationModal.vue';
import ApiServices from './modules/data-layer/services/ApiServices';
import accessibilityPlugin from './modules/plugins/accessibilityPlugin';
import contextPlugin from './modules/plugins/contextPlugin';
import customReportBuilder from './modules/plugins/customReportBuilder';
import indicatorPlugin from './modules/plugins/indicatorPlugin';
import insightSummaryPlugin from './modules/plugins/insightSummaryPlugin';
import metadataDrawer from './modules/plugins/metadataDrawer';
import reviewPlugin from './modules/plugins/reviewPlugin';
import screenshotManager from './modules/plugins/screenshotManager';
import testPlugin from './modules/plugins/testPlugin';
import testonePlugin from './modules/plugins/testonePlugin';
import trendStoryteller from './modules/plugins/trendStoryteller';

export default {
  components: {
    feedback,
    ShowDataSourcesList,
    WhatsNew,
    ShareSection,
    IndicatorExplanationModal,
    // ChatBot,
  },
  data() {
    return {
      pluginsImported: [], // Explicitly specify the type as an array of strings
      showDataSourceListComponent: false, // Replace with your actual state variable
      showWhatsNewComponent: false,
      whatsNewContent: [],
      showShareSectionComponent: false,
      showFunFact: false,
      showInterval: null,
      hideTimeout: null,
      funFactReadyTimeout: null,
      nugget: null,
      showDisablePrompt: false,
      whatsNewReadyTimeout: null,
      funFactDisabled: false,
    };
  },
  computed: {
    ...mapGetters('appearance', ['viewMode', 'fontSize', 'theme']),
    ...mapGetters('MSDAT_STORE', ['getConfigObject', 'getFunFact', 'getLoadingStatus']),

    // get fun fact disabled state from localStorage
    isFunFactDisabled() {
      return this.funFactDisabled;
    },
    dashboardConfigId() {
      return this.getConfigObject && this.getConfigObject.id ? this.getConfigObject.id : null;
    },
    isDashboardInitializationComplete() {
      return Boolean(this.dashboardConfigId) && this.getLoadingStatus === false;
    },
  },
  watch: {
    '$store.state.MSDAT_STORE.showDataSourceList': {
      // eslint-disable-next-line no-unused-vars
      handler(newVal, oldVal) {
        this.showDataSourceListComponent = newVal;
      },
      deep: true, // If you want to watch nested changes
    },
    '$store.state.MSDAT_STORE.showWhatsNew': {
      // eslint-disable-next-line no-unused-vars
      handler(newVal, oldVal) {
        this.showWhatsNewComponent = newVal;
      },
      deep: true, // If you want to watch nested changes
    },
    '$store.state.MSDAT_STORE.showShareSection': {
      // eslint-disable-next-line no-unused-vars
      handler(newVal, oldVal) {
        this.showShareSectionComponent = newVal;
      },
      deep: true, // If you want to watch nested changes
    },
    viewMode(newMode) {
      document.body.className = newMode;
    },
    fontSize(newSize) {
      document.documentElement.style.fontSize = newSize;
    },
    theme(newTheme) {
      document.documentElement.setAttribute('data-theme', newTheme);
    },
    dashboardConfigId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.scheduleWhatsNewCheck('dashboard-ready');
        }
      },
      immediate: true,
    },
    isDashboardInitializationComplete(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.scheduleWhatsNewCheck('dashboard-initialized');
        this.scheduleFunFactDisplay('dashboard-initialized');
      }
    },
    showDisablePrompt(newVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.showDisablePrompt = false;
        }, 10000);
      }
    },
  },
  async mounted() {
    this.initializeFunFactPreference();
    this.scheduleWhatsNewCheck('app-mounted');
    window.addEventListener('focus', this.handleWhatsNewRecheckTrigger);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // Repeat every 2 minutes
    this.showInterval = setInterval(() => {
      if (this.isDashboardInitializationComplete && !this.isFunFactDisabled) {
        this.showFunFactTemporarily();
      }
    }, 2 * 60 * 1000);

    // eslint-disable-next-line
    let plugins_imported = [];
    this.pluginsImported.push('accessibilityPlugin');
    if (!localStorage.getItem('accessibilityPlugin')) {
      localStorage.setItem('accessibilityPlugin', 'false');
    }

    if (localStorage.getItem('accessibilityPlugin') === 'true') {
      Vue.use(accessibilityPlugin);
    }

    this.pluginsImported.push('contextPlugin');
    if (!localStorage.getItem('contextPlugin')) {
      localStorage.setItem('contextPlugin', 'false');
    }

    if (localStorage.getItem('contextPlugin') === 'true') {
      Vue.use(contextPlugin);
    }

    this.pluginsImported.push('customReportBuilder');
    if (!localStorage.getItem('customReportBuilder')) {
      localStorage.setItem('customReportBuilder', 'false');
    }

    if (localStorage.getItem('customReportBuilder') === 'true') {
      Vue.use(customReportBuilder);
    }

    this.pluginsImported.push('indicatorPlugin');
    if (!localStorage.getItem('indicatorPlugin')) {
      localStorage.setItem('indicatorPlugin', 'false');
    }

    if (localStorage.getItem('indicatorPlugin') === 'true') {
      Vue.use(indicatorPlugin);
    }

    this.pluginsImported.push('insightSummaryPlugin');
    if (!localStorage.getItem('insightSummaryPlugin')) {
      localStorage.setItem('insightSummaryPlugin', 'false');
    }

    if (localStorage.getItem('insightSummaryPlugin') === 'true') {
      Vue.use(insightSummaryPlugin);
    }

    this.pluginsImported.push('metadataDrawer');
    if (!localStorage.getItem('metadataDrawer')) {
      localStorage.setItem('metadataDrawer', 'false');
    }

    if (localStorage.getItem('metadataDrawer') === 'true') {
      Vue.use(metadataDrawer);
    }

    this.pluginsImported.push('reviewPlugin');
    if (!localStorage.getItem('reviewPlugin')) {
      localStorage.setItem('reviewPlugin', 'false');
    }

    if (localStorage.getItem('reviewPlugin') === 'true') {
      Vue.use(reviewPlugin);
    }

    this.pluginsImported.push('screenshotManager');
    if (!localStorage.getItem('screenshotManager')) {
      localStorage.setItem('screenshotManager', 'false');
    }

    if (localStorage.getItem('screenshotManager') === 'true') {
      Vue.use(screenshotManager);
    }

    this.pluginsImported.push('testPlugin');
    if (!localStorage.getItem('testPlugin')) {
      localStorage.setItem('testPlugin', 'false');
    }

    if (localStorage.getItem('testPlugin') === 'true') {
      Vue.use(testPlugin);
    }

    this.pluginsImported.push('testonePlugin');
    if (!localStorage.getItem('testonePlugin')) {
      localStorage.setItem('testonePlugin', 'false');
    }

    if (localStorage.getItem('testonePlugin') === 'true') {
      Vue.use(testonePlugin);
    }

    this.pluginsImported.push('trendStoryteller');
    if (!localStorage.getItem('trendStoryteller')) {
      localStorage.setItem('trendStoryteller', 'false');
    }

    if (localStorage.getItem('trendStoryteller') === 'true') {
      Vue.use(trendStoryteller);
    }

    await this.SET_PLUGINS_IMPORTED(this.pluginsImported);
    document.body.className = this.viewMode;
    document.documentElement.style.fontSize = this.fontSize;
    document.documentElement.setAttribute('data-theme', this.theme);
  },
  methods: {
    ...mapActions(['SET_PLUGINS_IMPORTED']),
    ...mapMutations('MSDAT_STORE', ['toggleShowWhatsNew', 'SET_FUN_FACT']),
    getWhatsNewStorageKey(key) {
      return `msdat_whats_new_${key}`;
    },
    getStoredWhatsNewTimestamp(key) {
      const value = Number(localStorage.getItem(this.getWhatsNewStorageKey(key)));
      return Number.isFinite(value) ? value : 0;
    },
    setStoredWhatsNewTimestamp(key, value) {
      localStorage.setItem(this.getWhatsNewStorageKey(key), String(value));
    },
    getStoredWhatsNewSignature() {
      return localStorage.getItem(this.getWhatsNewStorageKey('last_seen_signature')) || '';
    },
    setStoredWhatsNewSignature(signature) {
      localStorage.setItem(this.getWhatsNewStorageKey('last_seen_signature'), signature);
    },
    buildWhatsNewSignature(items = []) {
      return items
        .map((item) => [
          item.id,
          item.updated_at || item.created_at || '',
          item.category_name || '',
          item.title || '',
          item.content || '',
          item.dashboard_name || '',
        ].join(':'))
        .join('|');
    },
    shouldDebugWhatsNew() {
      return localStorage.getItem(this.getWhatsNewStorageKey('debug')) === 'true';
    },
    logWhatsNewDebug(stage, details = {}) {
      if (!this.shouldDebugWhatsNew()) return;

      console.log('[WhatsNew Debug]', stage, {
        dashboardConfigId: this.dashboardConfigId,
        getLoadingStatus: this.getLoadingStatus,
        isDashboardInitializationComplete: this.isDashboardInitializationComplete,
        showDataSourceListComponent: this.showDataSourceListComponent,
        showShareSectionComponent: this.showShareSectionComponent,
        showWhatsNewComponent: this.showWhatsNewComponent,
        storedLastSeenAt: this.getStoredWhatsNewTimestamp('last_seen_at'),
        storedLastCheckedAt: this.getStoredWhatsNewTimestamp('last_checked_at'),
        storedLastSeenSignature: this.getStoredWhatsNewSignature(),
        ...details,
      });
    },
    canOpenWhatsNewModal() {
      return !this.showDataSourceListComponent && !this.showShareSectionComponent;
    },
    async openWhatsNewModal(signature) {
      if (!this.canOpenWhatsNewModal()) {
        this.logWhatsNewDebug('open-blocked', {
          reason: 'blocking-modal-open',
        });
        return;
      }

      this.setStoredWhatsNewSignature(signature);
      this.setStoredWhatsNewTimestamp('last_seen_at', Date.now());
      this.logWhatsNewDebug('open-modal', {
        nextSignature: signature,
      });
      this.toggleShowWhatsNew();
    },
    shouldRecheckWhatsNew() {
      const sixHours = 6 * 60 * 60 * 1000;
      const lastCheckedAt = this.getStoredWhatsNewTimestamp('last_checked_at');
      return !lastCheckedAt || Date.now() - lastCheckedAt >= sixHours;
    },
    scheduleWhatsNewCheck(reason = 'manual') {
      if (!this.isDashboardInitializationComplete) {
        this.logWhatsNewDebug('schedule-skipped', { reason });
        return;
      }

      if (this.whatsNewReadyTimeout) {
        clearTimeout(this.whatsNewReadyTimeout);
      }

      this.logWhatsNewDebug('schedule-queued', { reason });
      this.whatsNewReadyTimeout = setTimeout(() => {
        this.checkWhatsNew(reason);
      }, 60 * 1000);
    },
    async checkWhatsNew(reason = 'manual') {
      if (!this.isDashboardInitializationComplete) {
        this.logWhatsNewDebug('check-skipped', { reason });
        return;
      }

      try {
        const hasCheckedBefore = this.getStoredWhatsNewTimestamp('last_checked_at') > 0;
        const response = await ApiServices.getWhatsNew();
        const results = Array.isArray(response?.data?.results) ? response.data.results : [];
        const signature = this.buildWhatsNewSignature(results);
        const lastSeenSignature = this.getStoredWhatsNewSignature();
        const lastSeenAt = this.getStoredWhatsNewTimestamp('last_seen_at');
        const oneDay = 24 * 60 * 60 * 1000;
        const shouldShowForDailyView = !lastSeenAt || Date.now() - lastSeenAt >= oneDay;
        const shouldShowForChange = Boolean(signature) && signature !== lastSeenSignature;
        const shouldShowForFirstLoad = Boolean(signature) && !hasCheckedBefore;
        const canOpen = this.canOpenWhatsNewModal();

        this.whatsNewContent = results;
        this.setStoredWhatsNewTimestamp('last_checked_at', Date.now());
        this.logWhatsNewDebug('check-results', {
          reason,
          resultsLength: results.length,
          latestSignature: signature,
          hasCheckedBefore,
          shouldShowForDailyView,
          shouldShowForChange,
          shouldShowForFirstLoad,
          canOpen,
        });

        if (!results.length || !canOpen) {
          this.logWhatsNewDebug('check-no-open', {
            reason,
            resultsLength: results.length,
            canOpen,
          });
          return;
        }

        if (shouldShowForFirstLoad || shouldShowForChange || shouldShowForDailyView) {
          await this.openWhatsNewModal(signature);
        } else {
          this.logWhatsNewDebug('check-no-open', {
            reason,
            resultsLength: results.length,
            canOpen,
            shouldShowForDailyView,
            shouldShowForChange,
            shouldShowForFirstLoad,
          });
        }
      } catch (error) {
        this.logWhatsNewDebug('check-error', {
          reason,
          error: error?.message || error,
        });
        console.error('Failed to fetch Whats New content:', error);
      }
    },
    handleWhatsNewRecheckTrigger() {
      if (document.hidden || !this.isDashboardInitializationComplete || !this.shouldRecheckWhatsNew()) {
        this.logWhatsNewDebug('focus-skip', {
          documentHidden: document.hidden,
          shouldRecheck: this.shouldRecheckWhatsNew(),
        });
        return;
      }

      this.checkWhatsNew('focus');
    },
    handleVisibilityChange() {
      if (document.hidden || !this.shouldRecheckWhatsNew()) {
        this.logWhatsNewDebug('visibility-skip', {
          documentHidden: document.hidden,
          shouldRecheck: this.shouldRecheckWhatsNew(),
        });
        return;
      }

      this.checkWhatsNew('visibility');
    },

    async showFunFactTemporarily() {
      if (this.isFunFactDisabled) {
        this.showFunFact = false;
        return;
      }

      if (this.getConfigObject.id === undefined) {
        return;
      }
      try {
        const payload = {
          dashboard_id: this.getConfigObject.id,
        };

        const result = await ApiServices.getFunFact(payload);

        // ✅ Only show when webhook responds successfully
        if (!result) return;
        this.SET_FUN_FACT(result.content);

        this.nugget = result.content;

        this.showFunFact = true;

        // Clear previous timeout
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }

        // Hide after 1 minute
        this.hideTimeout = setTimeout(() => {
          this.showFunFact = false;
        }, 20 * 1000);
      } catch (error) {
        console.error('Fun fact webhook error:', error);
        this.showFunFact = false;
      }
    },

    toggleDisablePrompt() {
      this.showDisablePrompt = !this.showDisablePrompt;
    },
    initializeFunFactPreference() {
      this.funFactDisabled = localStorage.getItem('funFactDisabled') === 'true';
    },
    scheduleFunFactDisplay() {
      if (!this.isDashboardInitializationComplete || this.isFunFactDisabled) {
        return;
      }

      if (this.funFactReadyTimeout) {
        clearTimeout(this.funFactReadyTimeout);
      }

      this.funFactReadyTimeout = setTimeout(() => {
        this.showFunFactTemporarily();
      }, 30 * 1000);
    },

    toggleFunFact() {
      localStorage.setItem('funFactDisabled', 'false');
      this.funFactDisabled = false;
      this.nugget = this.getFunFact;
      this.showFunFact = Boolean(this.nugget);

      if (!this.nugget && this.isDashboardInitializationComplete) {
        this.showFunFactTemporarily();
      }
    },

    disableFunFact() {
      localStorage.setItem('funFactDisabled', 'true');
      this.funFactDisabled = true;
      this.showFunFact = false;
      this.showDisablePrompt = false;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      if (this.funFactReadyTimeout) {
        clearTimeout(this.funFactReadyTimeout);
        this.funFactReadyTimeout = null;
      }
    },

    closeFunFact() {
      this.showFunFact = false;

      // Clear timeout so it doesn't re-hide later
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    },

    // Live plugin toggling without reload
    onPluginsChanged({ plugin, value }) {
      const registry = {
        accessibilityPlugin,
        contextPlugin,
        customReportBuilder,
        indicatorPlugin,
        insightSummaryPlugin,
        metadataDrawer,
        reviewPlugin,
        screenshotManager,
        testPlugin,
        testonePlugin,
        trendStoryteller,
      };

      const pkg = registry[plugin];
      if (!pkg) return;

      if (value) {
        try {
          Vue.use(pkg);
        } catch (e) {
          // already installed or plugin guarded; ignore
        }

        if (Vue.prototype.$pluginBus) {
          Vue.prototype.$pluginBus.$emit('plugin:toggle', { plugin, enabled: true });
          Vue.prototype.$pluginBus.$emit('plugin:enable', plugin);
          Vue.prototype.$pluginBus.$emit(`plugin:enable:${plugin}`);
        }
        this.$root.$emit('plugin:enable', plugin);
      } else {
        if (Vue.prototype.$pluginBus) {
          Vue.prototype.$pluginBus.$emit('plugin:toggle', { plugin, enabled: false });
          Vue.prototype.$pluginBus.$emit('plugin:disable', plugin);
          Vue.prototype.$pluginBus.$emit(`plugin:disable:${plugin}`);
        }
        this.$root.$emit('plugin:disable', plugin);
      }
    },
  },

  created() {
    // global plugin bus for cross-cutting enable/disable notifications
    if (!Vue.prototype.$pluginBus) {
      Vue.prototype.$pluginBus = new Vue();
    }
    // listen to plugin change events emitted from settings or header
    this.$root.$on('plugins:changed', this.onPluginsChanged);
  },
  destroyed() {
    this.$root.$off('plugins:changed', this.onPluginsChanged);
  },
  beforeDestroy() {
    // Cleanup timers
    if (this.showInterval) clearInterval(this.showInterval);
    if (this.hideTimeout) clearTimeout(this.hideTimeout);
    if (this.funFactReadyTimeout) clearTimeout(this.funFactReadyTimeout);
    if (this.whatsNewReadyTimeout) clearTimeout(this.whatsNewReadyTimeout);
    window.removeEventListener('focus', this.handleWhatsNewRecheckTrigger);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
</script>

<style lang="scss">
.custom-swal-image {
  margin: 0px !important; /* Adjust the margin as needed */
  float: left; /* Align the image to the left of the text */
}
.datasource-list {
  position: fixed;
  right: 10px;
  z-index: 999999;
  top: 10rem;
  height: 48rem;
}

.fun-fact {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  width: min(34rem, calc(100vw - 2.5rem));
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  overflow: hidden;
  padding: 1.4rem 1.5rem 1.35rem;
  border-radius: 1.6rem;
  background:
    radial-gradient(circle at top right, rgba(214, 169, 69, 0.18), transparent 32%),
    linear-gradient(145deg, rgba(255, 250, 240, 0.98), rgba(250, 245, 233, 0.96));
  border: 1px solid rgba(196, 149, 43, 0.18);
  box-shadow:
    0 22px 60px rgba(49, 36, 11, 0.18),
    0 8px 20px rgba(130, 97, 27, 0.08);
  z-index: 9999;
  transform-origin: left bottom;
  will-change: transform, opacity;
}

.fun-fact-trigger {
  position: fixed;
  left: 1.35rem;
  bottom: 1.7rem;
  z-index: 9999;

  cursor: pointer;
  width: 4.15rem;
  height: 4.15rem;
  background:
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.95), rgba(247, 236, 211, 0.78)),
    linear-gradient(160deg, rgba(255, 248, 232, 0.92), rgba(244, 221, 165, 0.86));
  border: 1px solid rgba(201, 154, 51, 0.22);
  border-radius: 1.4rem;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow:
    0 18px 38px rgba(75, 54, 14, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.72);
  transition: transform 0.35s ease, box-shadow 0.35s ease, filter 0.35s ease;
  animation: floaty 5s ease-in-out infinite;
}

.fun-fact-trigger:hover {
  transform: translateY(-4px) scale(1.03);
  box-shadow:
    0 24px 44px rgba(75, 54, 14, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.bulb-svg {
  width: 2rem;
  height: 2rem;

  transition: all 0.3s ease;
  filter: drop-shadow(0 4px 8px rgba(245, 158, 11, 0.3))
    drop-shadow(0 0 16px rgba(245, 158, 11, 0.25));
}

.bulb-glow {
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 10px rgba(245, 158, 11, 0.6));
}

.fun-fact-trigger-ring,
.fun-fact-glow {
  position: absolute;
  inset: auto;
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(214, 169, 69, 0.24), transparent 70%);
  animation: pulse 2.5s infinite;
  z-index: -1;
  pointer-events: none;
}

.fun-fact-trigger-ring {
  width: 7rem;
  height: 7rem;
}

.fun-fact-glow {
  top: -3rem;
  right: -2.5rem;
  width: 11rem;
  height: 11rem;
  opacity: 0.75;
}

.fun-fact-trigger:hover .bulb-svg {
  transform: scale(1.08) translateY(-3px);
  filter: drop-shadow(0 6px 12px rgba(245, 158, 11, 0.5))
    drop-shadow(0 0 24px rgba(245, 158, 11, 0.4));
}

.fun-fact-trigger:hover .bulb-glow {
  filter: drop-shadow(0 0 18px rgba(245, 158, 11, 0.9));
}

.fun-fact-trigger:hover .bulb-glow {
  animation: flicker 0.6s ease-in-out;
}

/* animations */
@keyframes floaty {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@keyframes flicker {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.fun-fact-disable {
  position: absolute;
  top: 1rem;
  right: 3.4rem;
  width: 2rem;
  height: 2rem;
  background: rgba(255, 255, 255, 0.6);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  padding: 0;
  display: grid;
  place-items: center;
  backdrop-filter: blur(8px);
  transition: background 0.2s ease, transform 0.2s ease;
}

.fun-fact-disable:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
}

.funfact-modal {
  position: fixed;
  right: 2rem;
  bottom: 7.2rem;
  z-index: 9999;

  display: flex;
  gap: 0.9rem;
  align-items: flex-start;

  width: min(21rem, calc(100vw - 2.5rem));
  padding: 1rem 1.05rem;
  border-radius: 1.15rem;
  background: rgba(255, 251, 242, 0.96);
  border: 1px solid rgba(196, 149, 43, 0.16);
  box-shadow: 0 18px 36px rgba(49, 36, 11, 0.14);
  backdrop-filter: blur(14px);
}

.funfact-modal .icon {
  font-size: 1.35rem;
  color: #bc8a18;
}

.funfact-modal .title {
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: #2f2612;
}

.funfact-modal .desc {
  font-size: 0.84rem;
  color: #6e6141;
  margin-bottom: 0.9rem;
  line-height: 1.5;
}

.funfact-modal .actions {
  display: flex;
  gap: 0.65rem;
}

.funfact-modal button {
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.5rem 0.85rem;
  border-radius: 999px;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.funfact-modal .cancel {
  background: rgba(255, 255, 255, 0.9);
  color: #4c4128;
  border-color: rgba(196, 149, 43, 0.16);
}

.funfact-modal .confirm {
  background: linear-gradient(135deg, #bf8b18, #e0b24d);
  color: white;
  box-shadow: 0 10px 20px rgba(191, 139, 24, 0.2);
}

.funfact-modal button:hover {
  transform: translateY(-1px);
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.25s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

button:focus:not(:focus-visible) {
  outline: none;
}

/* Close (X) */
.fun-fact-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  background: rgba(255, 255, 255, 0.62);
  border: none;
  border-radius: 999px;
  color: #76684b;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.fun-fact-close-icon {
  width: 0.95rem;
  height: 0.95rem;
  display: block;
  stroke: currentColor;
  stroke-width: 2.2;
  stroke-linecap: round;
  fill: none;
}

.fun-fact-close:hover {
  color: #2f2612;
  background: rgba(255, 255, 255, 0.92);
  transform: translateY(-1px);
}

.fun-fact-icon {
  flex-shrink: 0;
  position: relative;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 1.15rem;
  background:
    linear-gradient(145deg, rgba(191, 139, 24, 0.98), rgba(229, 193, 106, 0.92));
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.34),
    0 16px 30px rgba(191, 139, 24, 0.22);
}

.bulb-icon {
  width: 1.55rem;
  height: 1.55rem;
}

.fun-fact-content {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  min-width: 0;
}

.fun-fact-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
}

.fun-fact-label {
  margin: 0;
  font-size: 0.64rem;
  font-weight: 700;
  color: #7b5b16;
  text-transform: uppercase;
  letter-spacing: 0.22em;
}

.fun-fact-kicker {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.62rem;
  border-radius: 999px;
  background: rgba(191, 139, 24, 0.08);
  color: #715626;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.fun-fact-divider {
  width: 3.1rem;
  height: 1px;
  background: linear-gradient(90deg, rgba(191, 139, 24, 0.8), rgba(191, 139, 24, 0));
}

.fun-fact-text {
  font-family: 'Baskerville', 'Georgia', 'Times New Roman', serif;
  font-size: clamp(1.12rem, 1rem + 0.55vw, 1.52rem);
  line-height: 1.62;
  color: #202217;
  font-weight: 500;
  letter-spacing: 0.012em;
  margin: 0;
  text-wrap: pretty;
}

.fun-fact-quote-mark {
  display: inline-block;
  margin-right: 0.18rem;
  color: #bc8a18;
  font-size: 1.3em;
  line-height: 0;
  transform: translateY(0.12em);
}

.fun-fact-caption {
  margin: 0;
  max-width: 28rem;
  color: #685c42;
  font-size: 0.78rem;
  line-height: 1.7;
  letter-spacing: 0.015em;
}

.fun-fact-slide-enter-active,
.fun-fact-slide-leave-active {
  transition:
    opacity 420ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 520ms cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 420ms cubic-bezier(0.16, 1, 0.3, 1);
}

.fun-fact-slide-enter-active .fun-fact-icon,
.fun-fact-slide-enter-active .fun-fact-meta,
.fun-fact-slide-enter-active .fun-fact-divider,
.fun-fact-slide-enter-active .fun-fact-text,
.fun-fact-slide-enter-active .fun-fact-caption,
.fun-fact-slide-leave-active .fun-fact-icon,
.fun-fact-slide-leave-active .fun-fact-meta,
.fun-fact-slide-leave-active .fun-fact-divider,
.fun-fact-slide-leave-active .fun-fact-text,
.fun-fact-slide-leave-active .fun-fact-caption {
  transition:
    opacity 360ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 460ms cubic-bezier(0.22, 1, 0.36, 1);
}

.fun-fact-slide-enter,
.fun-fact-slide-leave-to {
  opacity: 0;
  transform: translateY(24px) scale(0.972);
  box-shadow:
    0 12px 26px rgba(49, 36, 11, 0.1),
    0 4px 10px rgba(130, 97, 27, 0.05);
}

.fun-fact-slide-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.fun-fact-slide-enter .fun-fact-icon,
.fun-fact-slide-leave-to .fun-fact-icon {
  opacity: 0;
  transform: translateY(10px) scale(0.92);
}

.fun-fact-slide-enter .fun-fact-meta,
.fun-fact-slide-leave-to .fun-fact-meta {
  opacity: 0;
  transform: translateY(8px);
}

.fun-fact-slide-enter .fun-fact-divider,
.fun-fact-slide-leave-to .fun-fact-divider {
  opacity: 0;
  transform: scaleX(0.6);
  transform-origin: left center;
}

.fun-fact-slide-enter .fun-fact-text,
.fun-fact-slide-leave-to .fun-fact-text {
  opacity: 0;
  transform: translateY(12px);
}

.fun-fact-slide-enter .fun-fact-caption,
.fun-fact-slide-leave-to .fun-fact-caption {
  opacity: 0;
  transform: translateY(14px);
}

.fun-fact-slide-enter-active .fun-fact-icon {
  transition-delay: 70ms;
}

.fun-fact-slide-enter-active .fun-fact-meta,
.fun-fact-slide-enter-active .fun-fact-divider {
  transition-delay: 120ms;
}

.fun-fact-slide-enter-active .fun-fact-text {
  transition-delay: 170ms;
}

.fun-fact-slide-enter-active .fun-fact-caption {
  transition-delay: 230ms;
}

.fun-fact-slide-leave-active .fun-fact-caption {
  transition-delay: 0ms;
}

.fun-fact-slide-leave-active .fun-fact-text {
  transition-delay: 25ms;
}

.fun-fact-slide-leave-active .fun-fact-meta,
.fun-fact-slide-leave-active .fun-fact-divider {
  transition-delay: 45ms;
}

.fun-fact-slide-leave-active .fun-fact-icon {
  transition-delay: 65ms;
}

@media (max-width: 768px) {
  .fun-fact {
    right: 1rem;
    left: 1rem;
    bottom: 1rem;
    width: auto;
    padding: 1.1rem 1.05rem 1rem;
    gap: 0.85rem;
  }

  .fun-fact-trigger {
    left: 1rem;
    bottom: 1rem;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 1.2rem;
  }

  .fun-fact-disable {
    right: 3rem;
  }

  .funfact-modal {
    right: 1rem;
    left: 1rem;
    bottom: 5.8rem;
    width: auto;
  }
}

.whats-new {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 999999;
  top: 1px;
  height: 100vh;
}

/* Global Chatbot Styles */
.global-chatbot-wrapper {
  position: fixed;
  bottom: 100px;
  right: 24px;
  z-index: 99999;
}

.global-chat-trigger {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(0, 125, 83, 0.75) 0%, rgba(0, 168, 107, 0.75) 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(0, 125, 83, 0.35);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(4px);
}

.global-chat-trigger:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(0, 125, 83, 0.45);
  background: linear-gradient(135deg, rgba(0, 125, 83, 0.9) 0%, rgba(0, 168, 107, 0.9) 100%);
}

.global-chat-trigger:active {
  transform: scale(0.98);
}

.global-chat-trigger svg {
  width: 28px;
  height: 28px;
}

  .light {
  background-color: #ffffff;
  color: #000000;
}

.dark {
  background-color: #000000;
  color: #ffffff;
}

/* Define styles for different font sizes */
html {
  font-size: 16px; /* default */
}

html.small {
  font-size: 14px;
}

html.medium {
  font-size: 20px;
}

html.large {
  font-size: 24px;
}

/* Define styles for different themes */
[data-theme='default'] {
  --primary-color: #28a745;
  --secondary-color: #20c997;
  --background-color: #e9ecef;
}

[data-theme='calm'] {
  --primary-color: #007bff;
  --secondary-color: #17a2b8;
  --background-color: #e3f2fd;
}

[data-theme='neutral'] {
  --primary-color: #EA4700;
  --secondary-color: #EE6C33;
  --background-color: #FBDACC;
}

/* Dark Mode Styles */
[data-theme='dark'] {
  --bg-primary: #1a1a1a;
  --bg-secondary: #2d2d2d;
  --bg-tertiary: #3a3a3a;
  --text-primary: #ffffff;
  --text-secondary: #cccccc;
  --text-muted: #888888;
  --border-color: #444444;
  --border-light: #555555;
  --hover-bg: #404040;
  --active-bg: #505050;
  --input-bg: #333333;
  --input-border: #666666;
  --button-primary: #007bff;
  --button-secondary: #6c757d;
  --success-color: #28a745;
  --warning-color: #ffc107;
  --danger-color: #dc3545;
  --info-color: #17a2b8;
}

/* Global Dark Mode Overrides */
[data-theme='dark'] body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

[data-theme='dark'] .card {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .card-header {
  background-color: var(--bg-tertiary);
  border-bottom-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .card-body {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .btn {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .btn:hover {
  background-color: var(--hover-bg);
  border-color: var(--border-light);
}

[data-theme='dark'] .btn-primary {
  background-color: var(--button-primary);
  border-color: var(--button-primary);
}

[data-theme='dark'] .btn-secondary {
  background-color: var(--button-secondary);
  border-color: var(--button-secondary);
}

[data-theme='dark'] .form-control {
  background-color: var(--input-bg);
  border-color: var(--input-border);
  color: var(--text-primary);
}

[data-theme='dark'] .form-control:focus {
  background-color: var(--input-bg);
  border-color: var(--button-primary);
  color: var(--text-primary);
}

[data-theme='dark'] .form-control::placeholder {
  color: var(--text-muted);
}

[data-theme='dark'] input[type="text"],
[data-theme='dark'] input[type="email"],
[data-theme='dark'] input[type="password"],
[data-theme='dark'] textarea,
[data-theme='dark'] select {
  background-color: var(--input-bg);
  border-color: var(--input-border);
  color: var(--text-primary);
}

[data-theme='dark'] .table {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .table thead th {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .table tbody tr {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme='dark'] .table tbody tr:hover {
  background-color: var(--hover-bg);
}

[data-theme='dark'] .table tbody td {
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .modal-content {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .modal-header {
  background-color: var(--bg-tertiary);
  border-bottom-color: var(--border-color);
}

[data-theme='dark'] .modal-body {
  background-color: var(--bg-secondary);
}

[data-theme='dark'] .modal-footer {
  background-color: var(--bg-tertiary);
  border-top-color: var(--border-color);
}

[data-theme='dark'] .dropdown-menu {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme='dark'] .dropdown-item {
  color: var(--text-primary);
}

[data-theme='dark'] .dropdown-item:hover {
  background-color: var(--hover-bg);
  color: var(--text-primary);
}

[data-theme='dark'] .nav-tabs .nav-link {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-secondary);
}

[data-theme='dark'] .nav-tabs .nav-link.active {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .alert {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .badge {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
}

/* Plugin Cards Dark Mode */
[data-theme='dark'] .plugin-item {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .plugin-item:hover {
  background-color: var(--hover-bg);
}

[data-theme='dark'] .plugin-item .card-title,
[data-theme='dark'] .plugin-item .card-text {
  color: var(--text-primary);
}

/* Notification Items Dark Mode */
[data-theme='dark'] .notification-item {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .notification-item:hover {
  background-color: var(--hover-bg);
}

/* Control Panel Dark Mode */
[data-theme='dark'] #control-panel {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel .label-text {
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel .check-label {
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel button {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel button:hover {
  background-color: var(--hover-bg);
}

[data-theme='dark'] #control-panel .dropdown-toggle {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel .dropdown-menu {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme='dark'] #control-panel .dropdown-item {
  color: var(--text-primary);
}

[data-theme='dark'] #control-panel .dropdown-item:hover {
  background-color: var(--hover-bg);
}

[data-theme='dark'] #control-panel .voice-control-button {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

/* Admin Dashboard Dark Mode */
[data-theme='dark'] .admin-info label {
  color: var(--text-primary);
}

[data-theme='dark'] .admin-info input:disabled {
  background-color: var(--input-bg);
  border-color: var(--input-border);
  color: var(--text-secondary);
}

[data-theme='dark'] .admin-info button {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .admin-info button:hover {
  background-color: var(--hover-bg);
}

[data-theme='dark'] .admin-info .text-muted {
  color: var(--text-muted);
}

/* Security Section Dark Mode */
[data-theme='dark'] .security-section .form-check-label {
  color: var(--text-primary);
}

[data-theme='dark'] .security-section .form-check-input {
  background-color: var(--input-bg);
  border-color: var(--input-border);
}

/* Header Dark Mode */
[data-theme='dark'] header {
  background-color: var(--bg-secondary) !important;
  border-bottom-color: var(--border-color) !important;
}

[data-theme='dark'] header .navbar-brand,
[data-theme='dark'] header .nav-link {
  color: var(--text-primary) !important;
}

[data-theme='dark'] header .navbar-toggler {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
}

/* Sidebar Dark Mode */
[data-theme='dark'] .sidebar {
  background-color: var(--bg-secondary);
  border-right-color: var(--border-color);
}

[data-theme='dark'] .sidebar .nav-link {
  color: var(--text-primary);
}

[data-theme='dark'] .sidebar .nav-link:hover {
  background-color: var(--hover-bg);
  color: var(--text-primary);
}

[data-theme='dark'] .sidebar .nav-link.active {
  background-color: var(--active-bg);
  color: var(--text-primary);
}

/* Footer Dark Mode */
[data-theme='dark'] footer {
  background-color: var(--bg-secondary);
  border-top-color: var(--border-color);
  color: var(--text-primary);
}

/* BootstrapVue Component Overrides */
[data-theme='dark'] .b-sidebar {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .b-sidebar .b-sidebar-header {
  background-color: var(--bg-tertiary);
  border-bottom-color: var(--border-color);
}

[data-theme='dark'] .b-sidebar .b-sidebar-body {
  background-color: var(--bg-secondary);
}

[data-theme='dark'] .b-toast {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

[data-theme='dark'] .b-toast .toast-header {
  background-color: var(--bg-tertiary);
  border-bottom-color: var(--border-color);
}

[data-theme='dark'] .b-modal .modal-content {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .b-dropdown .dropdown-menu {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme='dark'] .b-dropdown .dropdown-item {
  color: var(--text-primary);
}

[data-theme='dark'] .b-dropdown .dropdown-item:hover {
  background-color: var(--hover-bg);
}

/* Chart Containers Dark Mode */
[data-theme='dark'] .chart-container {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

[data-theme='dark'] .chart-container .highcharts-background {
  fill: var(--bg-secondary);
}

[data-theme='dark'] .chart-container .highcharts-title,
[data-theme='dark'] .chart-container .highcharts-subtitle {
  fill: var(--text-primary);
}

[data-theme='dark'] .chart-container .highcharts-axis-labels text {
  fill: var(--text-primary);
}

[data-theme='dark'] .chart-container .highcharts-tooltip {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
}

/* Loading States Dark Mode */
[data-theme='dark'] .loading-overlay {
  background-color: rgba(26, 26, 26, 0.8);
}

[data-theme='dark'] .spinner-border {
  border-color: var(--button-primary);
  border-right-color: transparent;
}

/* Error States Dark Mode */
[data-theme='dark'] .error-message {
  background-color: var(--bg-tertiary);
  border-color: var(--danger-color);
  color: var(--text-primary);
}

/* Success States Dark Mode */
[data-theme='dark'] .success-message {
  background-color: var(--bg-tertiary);
  border-color: var(--success-color);
  color: var(--text-primary);
}

/* Warning States Dark Mode */
[data-theme='dark'] .warning-message {
  background-color: var(--bg-tertiary);
  border-color: var(--warning-color);
  color: var(--text-primary);
}

/* Info States Dark Mode */
[data-theme='dark'] .info-message {
  background-color: var(--bg-tertiary);
  border-color: var(--info-color);
  color: var(--text-primary);
}

/* Focus States Dark Mode */
[data-theme='dark'] *:focus {
  outline-color: var(--button-primary);
}

/* Selection States Dark Mode */
[data-theme='dark'] ::selection {
  background-color: var(--button-primary);
  color: var(--text-primary);
}

/* Scrollbar Dark Mode */
[data-theme='dark'] ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

[data-theme='dark'] ::-webkit-scrollbar-track {
  background: var(--bg-primary);
}

[data-theme='dark'] ::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

[data-theme='dark'] ::-webkit-scrollbar-thumb:hover {
  background: var(--border-light);
}

/* Print Styles - Ensure dark mode doesn't affect printing */
@media print {
  [data-theme='dark'] * {
    color: black !important;
    background: white !important;
  }
}

</style>
